import styled from '@emotion/styled'

import { colors } from '@/styles/theme'
import { LegiaBlack, LegiaMedium, Text1, Text2 } from '@/styles/typography'
import { mediaUp } from '@/styles/media'

export const StepItem = styled.li`
  list-style: none;
  margin-bottom: 18px;

  &:last-child {
    margin-bottom: 40px;
  }

  ${mediaUp('lg')} {
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 80px;
    }
  }
`

export const Question = styled(Text1)`
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  ${mediaUp('lg')} {
    margin-bottom: 20px;
  }

  .legia-warszawa & {
    ${LegiaBlack};
    color: var(--mainCustom);
  }
`

export const Index = styled.span`
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.paleGrey};
  color: ${colors.darkSkyBlue};
  margin-inline-end: 18px;

  ${mediaUp('lg')} {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    margin-inline-end: 40px;
  }

  .legia-warszawa & {
    ${LegiaBlack};
    background-color: var(--tintCustom);
    color: var(--accentFirstCustom);
    border-radius: 0;
  }
`

export const Answer = styled(Text2)`
  padding-inline-start: 42px;

  ${mediaUp('lg')} {
    padding-inline-start: 88px;
  }

  .legia-warszawa & {
    ${LegiaMedium};
    color: var(--mainCustom);
  }
`
